import React from 'react';
import { node, string } from 'prop-types';

import styles from './AccountCard.scss';

const cx = require('classnames/bind').bind(styles);

export default function AccountCard({ children, borderColor }) {
  return (
    <div className={cx(styles.root, borderColor)}>
      <div className={styles.content}>{children}</div>
    </div>
  );
}

AccountCard.propTypes = {
  children: node.isRequired,
  borderColor: string,
};

AccountCard.defaultProps = {
  borderColor: '',
};



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountAchievements/components/AccountCard/AccountCard.jsx